import { useState } from "react";
import { createUseStyles } from "react-jss";
import SidebarLightbox from "../../refresh/SidebarLightbox";
import GenericOptions from "../GenericOptions";
import MovementOptions from "../MovementOptions";
import styles from "./sharedStyles";

const useStyles = createUseStyles({
  ...styles,
});

const EditElevateUpHotspot = ({
  show,
  hotspot,
  onClose,
  onComplete,
  account,
  editing,
  images,
}) => {
  const classes = useStyles();
  const [config, setConfig] = useState(hotspot);

  return (
    <SidebarLightbox
      show={show}
      onClose={onClose}
      sidebar={
        <>
          <h1 className={classes.title}>Edit Elevate Up Hotspot</h1>
          <p className={classes.subtitle}>Move with a little zoom, upwards</p>
          <div className={classes.grow} />
        </>
      }
    >
      <div className={classes.options}>
        <GenericOptions
          icon="Elevate Up"
          config={config}
          setConfig={setConfig}
          account={account}
          title={false}
        />
        <MovementOptions
          editing={editing}
          config={config}
          setConfig={setConfig}
          images={images}
          onComplete={onComplete}
        />
      </div>
    </SidebarLightbox>
  );
};

export default EditElevateUpHotspot;
